module.exports = new __parcel__URL__("bar-chart.e74215ec.jpg").toString();